<template>
  <v-container fluid>
    <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :styles="{width: '96%'}"
    />
    <v-spacer></v-spacer>
    <v-divider></v-divider>
    <v-spacer></v-spacer>
    <Bar
        :chart-options="chartBarOptions"
        :chart-data="chartDataBarVacation"
        :styles="{width: '99%'}"
    />
    <v-progress-linear
        indeterminate
        v-if="loading"
    >
    </v-progress-linear>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import {Line as LineChartGenerator} from 'vue-chartjs/legacy'
import {Bar} from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    BarElement,
    LinearScale,
    CategoryScale,
    PointElement
)


export default {
  name: 'BatchRunHistoryGraph',
  props: {
    'subheight': {type: [Number], default: 150},
  },

  components: {
    LineChartGenerator,
    Bar,
  },

  computed: {
    ...mapGetters('BatchRunHistoryGraph', ['getColumns']),
    ...mapFields('BatchRunHistoryGraph', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive', 'filters']),

    chartData() {
      let weekData = []
      this.itemList.forEach(item => weekData.push(item['year_week']))
      let performance1w = []
      this.itemList.forEach(item => performance1w.push(item['production_performance']))
      let performance3w = []
      this.itemList.forEach(item => performance3w.push(item['production_performance_3w']))
      let performance10w = []
      this.itemList.forEach(item => performance10w.push(item['production_performance_10w']))
      return {
        labels: weekData,
        datasets: [
          {
            label: 'W1',
            backgroundColor: this.w1Color,
            data: performance1w,
            lineTension: 0.3,
            borderColor: this.w1Color,
          },
          {
            label: 'W3',
            backgroundColor: this.w3Color,
            data: performance3w,
            lineTension: 0.3,
            borderColor: this.w3Color,
          },
          {
            label: 'W10',
            backgroundColor: this.w10Color,
            data: performance10w,
            lineTension: 0.3,
            borderColor: this.w10Color,
          },
        ],
      }
    },
    chartDataBarVacation() {
      let weekData = []
      this.itemList.forEach(item => weekData.push(item['year_week']))
      let work_by_plan = []
      this.itemList.forEach(item => work_by_plan.push(item['work_by_plan']))
      let sick_fte = []
      this.itemList.forEach(item => sick_fte.push(item['sick_fte']))
      let vacation_fte = []
      this.itemList.forEach(item => vacation_fte.push(item['vacation_fte']))
      let holiday_extra_fte = []
      this.itemList.forEach(item => holiday_extra_fte.push(item['holiday_extra_fte']))
      return {
        labels: weekData,
        datasets: [
          {
            label: 'work fte/plan fte',
            backgroundColor: this.work_plan_color,
            data: work_by_plan,
            borderColor: this.work_plan_color,
            stack: 1,
            yAxisID: "A",
          },
          {
            label: 'Holiday FTE',
            backgroundColor: this.vacation_color,
            data: vacation_fte,
            borderColor: this.vacation_color,
            stack: 0,
            yAxisID: "B",
          },
          {
            label: 'Holiday extra FTE',
            backgroundColor: this.holiday_extra_color,
            data: holiday_extra_fte,
            borderColor: this.holiday_extra_color,
            stack: 0,
            yAxisID: "B",
          },
          {
            label: 'Sick FTE',
            backgroundColor: this.sick_color,
            data: sick_fte,
            borderColor: this.sick_color,
            stack: 0,
            yAxisID: "B",
          },
        ],
      }
    },

  },

  methods: {
    ...mapActions('BatchRunHistoryGraph', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize);
    await this.fetchItemList()
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      w1Color: '#EF5350',
      w3Color: '#42A5F5',
      w10Color: '#66BB6A',
      work_plan_color: '#78909C',
      vacation_color: '#42A5F5',
      holiday_extra_color: '#D4E157',
      sick_color: '#E57373',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {'font': {size: 14, weight: 'bold'}},
          },
        },
        scales: {
          x: {
            ticks: {
              font: {size: 14, weight: 'bold'},
            }
          },
          y: {
            ticks: {
              font: {size: 14, weight: 'bold'},
            }
          },
        },
      },
      chartBarOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {'font': {size: 14, weight: 'bold'}},
          },
        },
        scales: {
          x: {
            ticks: {
              font: {size: 14, weight: 'bold'},
            }
          },
          A: {
            type: 'linear',
            position: 'left',
            title: {
              text: 'work fte/plan fte (%)',
              display: true,
              font: {size: 14, weight: 'bold'},
            },
            ticks: {
              font: {size: 14, weight: 'bold'},
            }
          },
          B: {
            type: 'linear',
            position: 'right',
            title: {
              text: 'FTE',
              display: true,
              font: {size: 14, weight: 'bold'},
            },
            ticks: {
              font: {size: 14, weight: 'bold'},
            }
          }
        }
      },
      graphLoaded: false,
    }
  }
}
</script>

<style>

</style>
